export default () => ({
  groups: {
    height: '100%',
    display: 'flex',
    paddingLeft: 14,
    paddingRight: 14
  }
});
